<template>
  <b-modal :id="`ProcedimentosDetalhes`"
           :ref="`ProcedimentosDetalhes`"
           no-close-on-backdrop
           no-close-on-esc
           class="ProcedimentosDetalhes"
           header-class="ProcedimentosDetalhes_header"
           body-class="ProcedimentosDetalhes_body"
           content-class="ProcedimentosDetalhes_content"
           size="xl"
           centered
           visible>
    <template slot="modal-header">
      <div>
        <b class="ml-2">Detalhes do Procedimento</b>
      </div>
    </template>
    <div class="row mb-3">
      <div class="col-3">
        <label class="label"
               for="">Procedimento</label>
        <div>
          {{ getLabelAcao(propProcedimento.acao) }}
        </div>
      </div>
      <div v-if="propProcedimento.acao == 'ALTERACAO_ESTADO_CIVIL'"
           class="col-3">
        <label class="label"
               for="">Motivo</label>
        <div>
          {{ getLabelMotivo(propProcedimento.motivo) }}
        </div>
      </div>
      <div class="col-3">
        <label class="label"
               for="">Origem</label>
        <div>
          {{ getLabelOrigem(propProcedimento.origem) }}
        </div>
      </div>
    </div>
    <div v-if="propProcedimento.origem === 'ESCRITURA'"
         class="row mb-3">
      <div class="col-3">
        <label class="label"
               for="">Data da Escritura</label>
        <div>
          {{ propProcedimento.data_escritura | date }}
        </div>
      </div>
      <div class="col-3">
        <label class="label"
               for="">Núm. Livro</label>
        <div>
          {{ propProcedimento.num_livro }}
        </div>
      </div>
      <div class="col-3">
        <label class="label"
               for="">Núm. Folha</label>
        <div>
          {{ propProcedimento.num_folha }}
        </div>
      </div>
    </div>
    <div v-if="propProcedimento.origem === 'ESCRITURA'"
         class="row mb-3">
      <div class="col-2">
        <label class="label"
               for="">UF</label>
        <div>
          {{ propProcedimento.uf || 'Não informado' }}
        </div>
      </div>
      <div class="col-4">
        <label class="label"
               for="">Cidade</label>
        <div>
          {{ propProcedimento.cidade || 'Não informado' }}
        </div>
      </div>
      <div class="col-6">
        <label class="label"
               for="">Cartório</label>
        <div>
          {{ propProcedimento.cartorio || 'Não informado' }}
        </div>
      </div>
    </div>
    <div v-if="propProcedimento.origem === 'MANDADO'"
         class="row mb-3">
      <div class="col-3">
        <label class="label"
               for="">Data da Sentença</label>
        <div>
          {{ propProcedimento.data_sentenca | date }}
        </div>
      </div>
      <div class="col-3">
        <label class="label"
               for="">Data do Transito em Julgado</label>
        <div>
          {{ propProcedimento.data_sentenca | date }}
        </div>
      </div>
      <div class="col-3">
        <label class="label"
               for="">Data do Mandado</label>
        <div v-if="propProcedimento.data_mandado">
          {{ propProcedimento.data_mandado | date }}
        </div>
        <div v-else>
          Não informado
        </div>
      </div>
      <div class="col-3">
        <label class="label"
               for="">Número do Processo</label>
        <div v-if="propProcedimento.num_processo">
          {{ propProcedimento.num_processo }}
        </div>
        <div v-else>
          Não informado
        </div>
      </div>
    </div>
    <div v-if="propProcedimento.origem === 'MANDADO'"
         class="row mb-3">
      <div class="col-2">
        <label class="label"
               for="">UF</label>
        <div>
          {{ propProcedimento.uf || 'Não informado' }}
        </div>
      </div>
      <div class="col-4">
        <label class="label"
               for="">Comarca</label>
        <div>
          {{ propProcedimento.comarca || 'Não informado' }}
        </div>
      </div>
      <div class="col-3">
        <label class="label"
               for="">Vara</label>
        <div>
          {{ propProcedimento.vara || 'Não informado' }}
        </div>
      </div>
      <div class="col-3">
        <label class="label"
               for="">Juiz</label>
        <div>
          {{ propProcedimento.juiz || 'Não informado' }}
        </div>
      </div>
    </div>
    <div v-if="propProcedimento.acao == 'ALTERACAO_ESTADO_CIVIL'"
         class="row mb-3">
      <div class="col-6">
        <label class="label"
               for="">Nome após a alteração - Cônjuge 1</label>
        <div>
          {{ propProcedimento.nome_conjuge_1 || 'Não informado' }}
        </div>
      </div>
      <div class="col-6">
        <label class="label"
               for="">Nome após a alteração - Cônjuge 2</label>
        <div>
          {{ propProcedimento.nome_conjuge_2 || 'Não informado' }}
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-3">
        <label class="label"
               for="">Data da solicitação</label>
        <div v-if="propProcedimento.data_averbacao">
          {{ propProcedimento.data_averbacao | date }}
        </div>
        <div v-else>
          Não informado
        </div>
      </div>
      <div class="col-3">
        <label class="label"
               for="">Isento de emolumentos</label>
        <div>
          {{ propProcedimento.isento ? 'Sim' : 'Não' }}
        </div>
      </div>
      <div class="col-3">
        <label class="label"
               for="">Número do protocolo</label>
        <div v-if="num_protocolo">
          {{ num_protocolo }}
        </div>
        <div v-else>
          Não informado
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-3">
        <label class="label"
               for="">CPF Requerente</label>
        <div v-if="propProcedimento.cpf_requerente">
          {{ propProcedimento.cpf_requerente | cpf }}
        </div>
        <div v-else>
          Não informado
        </div>
      </div>
      <div class="col-3">
        <label class="label"
               for="">Nome Requerente</label>
        <div>
          {{ propProcedimento.nome_requerente || 'Não informado' }}
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-6">
        <label class="label"
               for="">Selos</label>
        <div v-for="(num, index) in selos"
             :key="index">
          {{ num }}
        </div>
        <div v-if="!selos.length">
          Nenhum selo vinculado ao procedimento
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-12">
        <label class="label"
               for="">Texto do Procedimento</label>
        <div class="text-break">
          {{ propProcedimento.texto_procedimento || 'Não informado' }}
        </div>
      </div>
    </div>
    <div v-if="propProcedimento.procedimentoArquivo.length">
      <div v-if="!documentos || !documentos.length"
           class="row justify-content-center mt-4">
        <div class="col-12 d-flex justify-content-center">
          <b-spinner variant="primary" />
        </div>
        <div class="col-12 d-flex justify-content-center mt-2">
          <small>Carregando documentos...</small>
        </div>
      </div>
      <div v-else
           class="row">
        <div class="col-3">
          <div class="MenuImagens">
            <div class="MenuImagens_header">
              Imagens
            </div>
            <div v-for="(documento, index) in documentos"
                 :key="index"
                 class="MenuImagens_imagem"
                 :class="{'MenuImagens_imagem_active': imageActive === index}"
                 @click="changePDF(documento, index)">
              Documento {{ index + 1 }}
            </div>
          </div>
        </div>
        <div class="col-9">
          <div class="Imagem">
            <object class="document-preview embed-responsive"
                    :data="urlPDF"
                    type="application/pdf">
              <p>Seu browser não suporta arquivos pdf diretamente ou este arquivo não existe. Você pode tentar efetuar o download clicando.</p>
            </object>
          </div>
        </div>
      </div>
    </div>
    <div v-else
         class="row">
      <div class="col-12">
        <b>
          Nenhum documento adicionado ao procedimento
        </b>
      </div>
    </div>

    <template slot="modal-footer">
      <button class="btn btn-sm btn-light px-3"
              @click="hide()">
        Voltar
      </button>
      <button class="btn btn-sm btn-secondary ml-2"
              @click="editar()">
        Editar
      </button>
    </template>
  </b-modal>
</template>

<script>
  //Services
  import ProcedimentoService from "@/services/ProcedimentoService"
  import ProtocolosService from "@/services/Protocolos"

  export default {
    name: 'ProcedimentosDetalhes',
    props: {
      propProcedimento: { type: Object, default: () => ({})}
    },
    data () {
      return {
        localData: {
          documento: {}
        },
        imageActive: 0,
        documentos: [],
        urlPDF: null,
        acoes: [
          { label: 'Alteração de Estado Civil', value: 'ALTERACAO_ESTADO_CIVIL' },
          { label: 'Inteiro Teor', value: 'INTEIRO_TEOR' }
        ],
        tiposAlteracao: [
          { label: 'Divórcio', value: 'DIVORCIO', origens: ['ESCRITURA', 'MANDADO'] },
          { label: 'Separação', value: 'SEPARACAO', origens: ['ESCRITURA', 'MANDADO'] },
          { label: 'Reconciliação', value: 'RECONCILIACAO', origens: ['ESCRITURA', 'MANDADO'] },
          { label: 'Desquite', value: 'DESQUITE', origens: ['MANDADO'] },
          { label: 'Anulação', value: 'ANULACAO', origens: ['MANDADO'] },
        ],
        origens: [
          { label: 'Mandado Judicial', value: 'MANDADO' },
          { label: 'Escritura', value: 'ESCRITURA'},
          { label: 'Digitado', value: 'DIGITADO'}
        ],
        num_protocolo: null,
        selos: []
      }
    },
    mounted () {
      this.getDocumentos()

      if (this.propProcedimento.protocolo_id) {
        this.getProtocolo(this.propProcedimento.protocolo_id)
      }

      this.getSelos()
    },
    methods: {
      hide () {
        this.$emit('hide')
      },
      editar () {
        this.$emit('editar', this.propProcedimento)
      },
      async getProtocolo (id) {
        try {
          const protocolo = await ProtocolosService.show(id)

          this.num_protocolo = protocolo.numero
        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', 'Erro!', message.message)
        }
      },
      async getDocumentos () {
        if (!this.propProcedimento.procedimentoArquivo.length) return

        try {
          const documentos = await ProcedimentoService.getDocumentos(this.propProcedimento.procedimento_id)

          if (documentos && documentos.length) {
            const imagens = []

            for (const documento of documentos) {
              const res = await ProcedimentoService.getPDF(documento.url)

              if (res) {
                this.propProcedimento.procedimentoArquivo.forEach(arq => {
                  if (arq.procedimento_arquivo_id === documento.procedimento_arquivo_id) {
                    arq.pdf = res
                  }
                })

                imagens.push(res)
              }
            }

            this.documentos = imagens

            this.changePDF(imagens[0], 0)

          }
        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        }
      },
      changePDF (documento, index) {
        let blob = new Blob([documento], { type: 'application/pdf' })
        let url = window.URL.createObjectURL(blob)
        this.urlPDF = url

        this.imageActive = index
      },
      getLabelMotivo (motivo) {
        const tipoAlteracao = this.tiposAlteracao.find(tipo => tipo.value === motivo)

        if (tipoAlteracao) {
          return tipoAlteracao.label
        }

        return 'Não Informado'
      },
      getLabelAcao (acao) {
        const tipoAcao = this.acoes.find(action => action.value === acao)

        if (tipoAcao) {
          return tipoAcao.label
        }

        return 'Não Informado'
      },
      getLabelOrigem (origem) {
        const origin = this.origens.find(origin => origin.value === origem)

        if (origin) {
          return origin.label
        }

        return 'Não Informado'
      },
      getSelos () {
        if (!this.propProcedimento.ordemServico) return

        this.propProcedimento.ordemServico.itens.forEach(item => {
          item.seloItemOs.forEach(seloItem => {
            this.selos.push(seloItem.selo.num_selo)
          })
        })
      }
    }
  }
</script>

<style lang="scss">
  .ProcedimentosDetalhes {
    &_header {
      background: #074f7f;
      color: #fff;
      padding: 10px;
      font-size: 20px;
      font-weight: bold;
      border-radius: 0px;
    }

    &_content {
      border-radius: 0px;
    }

    &_body {
      padding: 20px;
    }

    &_body label {
      font-size: 16px;
      font-weight: 500;
      color: #000;
    }
  }

  .MenuImagens {
    border: 1px solid #000;

    &_header {
      background: #000;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      padding: 5px;
    }

    &_imagem {
      cursor: pointer;
      color: #000;
      font-size: 15px;
      padding: 5px;
      background: #fff;

      &_active {
        background: #086aae !important;
        color: #fff;
        transition: 0.2s;
      }
    }

    &_imagem:hover {
      background: #e2e2e2;
      transition: 0.2s;
    }
  }

  .Imagem {
    border: 1px solid black;
    width: 100%;
  }

  .document-preview {
    height: 500px !important;
  }
</style>
